
<div *ngIf="card" class="btn-track chip d-inline-block bg-color-gold-wa px-2 py-1" (click)="cardService.openBestOffer(card)">
    <div class="d-flex flex-row align-items-center">
        <img class="picto-medium" src="../../../assets/images/231116/pictos/MyChannels.svg" />
        <div class="typo-chip px-2">{{ 'wap1_c_tube_tube' | translate }}</div>
    </div>
</div>